


















































































import Vue from 'vue';
import axios from 'axios';
import { WebhookEndpointEventType, Campaign, WebhookEndpoint } from '@/types';
import { Utils } from '@/Utils';

interface Data {
    endpointUrl: string;
    selectedEventType: string;
    selectedCampaign?: Campaign;

    campaigns: Campaign[];
    eventTypes: string[];

    callback?: Function;
}

export default Vue.extend({
    data(): Data {
        return {
            endpointUrl: '',
            selectedCampaign: undefined,
            selectedEventType: WebhookEndpointEventType[WebhookEndpointEventType.CampaignUserSignup],

            campaigns: [],
            eventTypes: Object.keys(WebhookEndpointEventType).filter(key => isNaN(Number(key))),
        };
    },
    methods: {
        beforeOpen(e) {
            this.campaigns = e.params.campaigns
            this.selectedCampaign = this.campaigns[0];
            this.callback = e.params.callback
        },
        handleSave() {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/weblinks/${this.$data.selectedCampaign.id}/addwebhook`, {
                    endpointUrl: this.$data.endpointUrl,
                    eventType: this.$data.selectedEventType
                })
                .then(res => {
                    if (res.status !== 200) {
                        Utils.toastError('Unable to add webhook: ' + res.status);
                    } else {
                        var resWebhookEndpoint: WebhookEndpoint = res.data;

                        this.$modal.hide('add-webhook-dialog', {});
                        this.callback?.(resWebhookEndpoint);
                    }
                })
                .catch(err => {
                    Utils.toastError('Something went wrong. Try again later.');
                });
        },
    },
});
